import React, { useEffect, useState, useMemo } from "react";
import { connect } from "react-redux";
import {
	IconBuilding,
	IconMapPin,
	IconPhone,
	IconClock,
	IconStar,
	IconShare,
	IconCheck,
	IconAlertTriangle,
	IconEdit,
	IconUpload,
	IconMenu2,
	IconCurrentLocation,
	IconX,
	IconImage,
} from "@tabler/icons-react";
import DashboardLayout from "../../hocs/layout/DashboardLayout";
import { Meta } from "../../components/navigation/Helmet";
import axios from "axios";

// Componente Modal para subir menús
const MenuUploadModal = ({ onClose, onUpload, uploading, menuTypes }) => {
	const [menuData, setMenuData] = useState({
		title: "",
		menu_type: "",
		description: "",
		url: null,
		valid_from: "",
		valid_to: "",
		is_active: true,
	});

	const [errors, setErrors] = useState({});

	const handleInputChange = (e) => {
		const { name, value, type, checked } = e.target;
		setMenuData((prev) => ({
			...prev,
			[name]: type === "checkbox" ? checked : value,
		}));

		// Limpiar error cuando el usuario empiece a escribir
		if (errors[name]) {
			setErrors((prev) => ({ ...prev, [name]: null }));
		}
	};

	const validateUrl = (u) => {
		try {
			if (!u || !u.trim()) return false;
			new URL(u);
			return true;
		} catch {
			return false;
		}
	};
	const validateForm = () => {
		const newErrors = {};

		if (!menuData.title.trim()) {
			newErrors.title = "El título es obligatorio";
		}

		if (!menuData.menu_type) {
			newErrors.menu_type = "Selecciona un tipo de menú";
		}

		if (!menuData.url) {
			newErrors.url = "	Ingresa una URL valida";
		}

		setErrors(newErrors);
		return Object.keys(newErrors).length === 0;
	};

	const handleSubmit = async (e) => {
		e.preventDefault();

		if (!validateForm()) {
			return;
		}

		await onUpload(menuData);
	};

	return (
		<div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
			<div className="bg-white rounded-lg max-w-md w-full max-h-[90vh] overflow-y-auto">
				<div className="flex items-center justify-between p-6 border-b">
					<h3 className="text-lg font-semibold text-gray-900">Subir Menú</h3>
					<button
						onClick={onClose}
						className="text-gray-400 hover:text-gray-600"
					>
						<IconX className="h-5 w-5" />
					</button>
				</div>

				<form onSubmit={handleSubmit} className="p-6 space-y-4">
					{/* Título */}
					<div>
						<label className="block text-sm font-medium text-gray-700 mb-1">
							Título del Menú *
						</label>
						<input
							type="text"
							name="title"
							value={menuData.title}
							onChange={handleInputChange}
							className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 ${
								errors.title ? "border-red-500" : "border-gray-300"
							}`}
							placeholder="Ej: Menú Principal, Carta de Postres..."
						/>
						{errors.title && (
							<p className="text-red-500 text-xs mt-1">{errors.title}</p>
						)}
					</div>

					{/* Tipo de Menú */}
					<div>
						<label className="block text-sm font-medium text-gray-700 mb-1">
							Tipo de Menú *
						</label>
						<select
							name="menu_type"
							value={menuData.menu_type}
							onChange={handleInputChange}
							className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 ${
								errors.menu_type ? "border-red-500" : "border-gray-300"
							}`}
						>
							<option value="">Seleccionar tipo</option>
							{menuTypes.map((type) => (
								<option key={type.value} value={type.value}>
									{type.label}
								</option>
							))}
						</select>
						{errors.menu_type && (
							<p className="text-red-500 text-xs mt-1">{errors.menu_type}</p>
						)}
					</div>

					{/* Descripción */}
					<div>
						<label className="block text-sm font-medium text-gray-700 mb-1">
							Descripción
						</label>
						<textarea
							name="description"
							value={menuData.description}
							onChange={handleInputChange}
							rows={3}
							className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
							placeholder="Descripción opcional del menú..."
						/>
					</div>

					{/* URL */}
										<div>
						<label className="block text-sm font-medium text-gray-700 mb-1">
							URL del Menú *
						</label>
						<input
							type="url"
							name="url"
              value={menuData.url}
              onChange={handleInputChange}
              placeholder="https://ejemplo.com/menus/menu-principal.pdf"
              className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 ${
                errors.url ? 'border-red-500' : 'border-gray-300'
              }`}
            />
            {errors.url && <p className="text-red-500 text-xs mt-1">{errors.url}</p>}
          </div>

					{/* Fechas de validez */}
					<div className="grid grid-cols-2 gap-4">
						<div>
							<label className="block text-sm font-medium text-gray-700 mb-1">
								Válido desde
							</label>
							<input
								type="date"
								name="valid_from"
								value={menuData.valid_from}
								onChange={handleInputChange}
								className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
							/>
						</div>
						<div>
							<label className="block text-sm font-medium text-gray-700 mb-1">
								Válido hasta
							</label>
							<input
								type="date"
								name="valid_to"
								value={menuData.valid_to}
								onChange={handleInputChange}
								className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
							/>
						</div>
					</div>

					{/* Estado activo */}
					<div className="flex items-center">
						<input
							type="checkbox"
							name="is_active"
							checked={menuData.is_active}
							onChange={handleInputChange}
							className="mr-2"
						/>
						<label className="text-sm text-gray-700">
							Menú activo (visible para los clientes)
						</label>
					</div>

					{/* Botones */}
					<div className="flex gap-3 pt-4">
						<button
							type="button"
							onClick={onClose}
							className="flex-1 px-4 py-2 text-gray-700 border border-gray-300 rounded-md hover:bg-gray-50"
							disabled={uploading}
						>
							Cancelar
						</button>
						<button
							type="submit"
							disabled={uploading}
							className={`flex-1 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2`}
						>
							{uploading ? (
								<>
									<div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
									<span>Subiendo...</span>
								</>
							) : (
								<>
									<IconUpload className="h-4 w-4" />
									<span>Subir Menú</span>
								</>
							)}
						</button>
					</div>
				</form>
			</div>
		</div>
	);
};

const getToken = () => localStorage.getItem("access") || "";
const API = "/api";

function BusinessProfile({ user, access }) {
	const [businessProfile, setBusinessProfile] = useState(null);
	const [loading, setLoading] = useState(true);
	const [saving, setSaving] = useState(false);
	const [error, setError] = useState("");
	const [success, setSuccess] = useState("");
	const [activeTab, setActiveTab] = useState("basic");
	const [gettingLocation, setGettingLocation] = useState(false);
	const [locationError, setLocationError] = useState("");
	const [uploadingMenu, setUploadingMenu] = useState(false);
	const [showMenuModal, setShowMenuModal] = useState(false);
	const [uploadingLogo, setUploadingLogo] = useState(false);
	const [logoPreview, setLogoPreview] = useState(null);

	const businessTypes = useMemo(
		() => [
			{ value: "RESTAURANT", label: "Restaurante" },
			{ value: "COMPANY", label: "Empresa" },
			{ value: "CAFE", label: "Cafetería" },
			{ value: "BAR", label: "Bar" },
			{ value: "HOTEL", label: "Hotel" },
			{ value: "RETAIL", label: "Tienda/Retail" },
			{ value: "SERVICE", label: "Servicio" },
			{ value: "OTHER", label: "Otro" },
		],
		[]
	);

	const menuTypes = useMemo(
		() => [
			{ value: "GENERAL", label: "General" },
			{ value: "BREAKFAST", label: "Desayunos" },
			{ value: "LUNCH", label: "Almuerzos" },
			{ value: "DINNER", label: "Cenas" },
			{ value: "DRINKS", label: "Bebidas" },
			{ value: "DESSERTS", label: "Postres" },
			{ value: "SEASONAL", label: "Temporada" },
			{ value: "OTHER", label: "Otro" },
		],
		[]
	);

	const commonFeatures = useMemo(
		() => [
			"WiFi",
			"Estacionamiento",
			"Domicilios",
			"Terraza",
			"Aire Acondicionado",
			"Reservas",
			"Tarjetas de Crédito",
			"Efectivo",
			"Música en Vivo",
			"Pet Friendly",
			"Accesibilidad",
			"Zona Fumadores",
			"Bar",
			"Desayuno",
			"Almuerzo",
			"Cena",
			"Servicio 24h",
		],
		[]
	);

	const dayNames = useMemo(
		() => ({
			monday: "Lunes",
			tuesday: "Martes",
			wednesday: "Miércoles",
			thursday: "Jueves",
			friday: "Viernes",
			saturday: "Sábado",
			sunday: "Domingo",
		}),
		[]
	);

	const [formData, setFormData] = useState({
		business_name: "",
		business_type: "RESTAURANT",
		specialty: "",
		address: "",
		city: "",
		state: "",
		postal_code: "",
		country: "Colombia",
		latitude: "",
		longitude: "",
		phone_main: "",
		email_business: "",
		website: "",
		description: "",
		number_of_tables: "",
		founded_year: "",
		operating_hours: {
			monday: { open: "09:00", close: "18:00", closed: false },
			tuesday: { open: "09:00", close: "18:00", closed: false },
			wednesday: { open: "09:00", close: "18:00", closed: false },
			thursday: { open: "09:00", close: "18:00", closed: false },
			friday: { open: "09:00", close: "18:00", closed: false },
			saturday: { open: "09:00", close: "15:00", closed: false },
			sunday: { open: "09:00", close: "15:00", closed: true },
		},
		features: [],
		social_media: {
			facebook: "",
			instagram: "",
			twitter: "",
			linkedin: "",
			whatsapp: "",
		},
		ai_context: {},
	});

	const tabs = useMemo(
		() => [
			{ id: "basic", label: "Información Básica", icon: IconBuilding },
			{ id: "location", label: "Ubicación", icon: IconMapPin },
			{ id: "contact", label: "Contacto", icon: IconPhone },
			{ id: "hours", label: "Horarios", icon: IconClock },
			{ id: "features", label: "Servicios", icon: IconStar },
			{ id: "social", label: "Redes Sociales", icon: IconShare },
			{ id: "menus", label: "Menús", icon: IconMenu2 },
		],
		[]
	);

	useEffect(() => {
		fetchBusinessProfile();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const fetchBusinessProfile = async () => {
		try {
			setLoading(true);
			setError("");
			const token = getToken();
			const config = { headers: { Authorization: `JWT ${token}` } };

			const dashRes = await axios.get(
				`${process.env.REACT_APP_API_URL}${API}/dashboard/`,
				config
			);

			if (dashRes.data.business) {
				const business = dashRes.data.business;
				setBusinessProfile(business);

				// Limpiar horarios al cargar: si un día está cerrado, solo mantener closed: true
				const cleanedOperatingHours = {};
				const originalHours = business.operating_hours || {};

				Object.keys(originalHours).forEach((day) => {
					const dayData = originalHours[day];
					if (dayData && dayData.closed) {
						cleanedOperatingHours[day] = { closed: true };
					} else if (dayData) {
						cleanedOperatingHours[day] = {
							closed: false,
							open: dayData.open || "09:00",
							close: dayData.close || "18:00",
						};
					} else {
						// Día no definido, usar valores por defecto
						cleanedOperatingHours[day] = {
							closed: false,
							open: "09:00",
							close: "18:00",
						};
					}
				});

				// Asegurar que todos los días estén definidos
				const allDays = [
					"monday",
					"tuesday",
					"wednesday",
					"thursday",
					"friday",
					"saturday",
					"sunday",
				];
				allDays.forEach((day) => {
					if (!cleanedOperatingHours[day]) {
						cleanedOperatingHours[day] = {
							closed: false,
							open: "09:00",
							close: "18:00",
						};
					}
				});

				setFormData((prev) => ({
					...prev,
					business_name: business.business_name || "",
					business_type: business.business_type || "RESTAURANT",
					specialty: business.specialty || "",
					address: business.address || "",
					city: business.city || "",
					state: business.state || "",
					postal_code: business.postal_code || "",
					country: business.country || "Colombia",
					latitude: business.latitude || "",
					longitude: business.longitude || "",
					phone_main: business.phone_main || "",
					email_business: business.email_business || "",
					website: business.website || "",
					description: business.description || "",
					number_of_tables: business.number_of_tables || "",
					founded_year: business.founded_year || "",
					operating_hours: cleanedOperatingHours,
					features: business.features || [],
					social_media: {
						...prev.social_media,
						...(business.social_media || {}),
					},
					ai_context: business.ai_context || {},
				}));
			} else {
				setError("No tienes un perfil de negocio. Créalo desde el Dashboard.");
			}
		} catch (err) {
			setError("Error al cargar el perfil del negocio");
		} finally {
			setLoading(false);
		}
	};

	const handleInputChange = (e) => {
		const { name, value, type, checked } = e.target;
		if (name.includes(".")) {
			const [parent, child] = name.split(".");
			setFormData((prev) => ({
				...prev,
				[parent]: {
					...prev[parent],
					[child]: type === "checkbox" ? checked : value,
				},
			}));
		} else {
			setFormData((prev) => ({
				...prev,
				[name]: type === "checkbox" ? checked : value,
			}));
		}
	};

	const handleHoursChange = (day, field, value) => {
		setFormData((prev) => {
			const currentDay = prev.operating_hours[day] || {};

			// Si estamos marcando como cerrado, limpiar open y close
			if (field === "closed" && value === true) {
				return {
					...prev,
					operating_hours: {
						...prev.operating_hours,
						[day]: { closed: true },
					},
				};
			}

			// Si estamos desmarcando cerrado, establecer horarios por defecto
			if (field === "closed" && value === false) {
				return {
					...prev,
					operating_hours: {
						...prev.operating_hours,
						[day]: {
							closed: false,
							open: "09:00",
							close: "18:00",
						},
					},
				};
			}

			// Para cambios normales de horarios
			return {
				...prev,
				operating_hours: {
					...prev.operating_hours,
					[day]: { ...currentDay, [field]: value },
				},
			};
		});
	};

	const handleFeatureToggle = (feature) => {
		setFormData((prev) => ({
			...prev,
			features: prev.features.includes(feature)
				? prev.features.filter((f) => f !== feature)
				: [...prev.features, feature],
		}));
	};

	const getCurrentLocation = () => {
		if (!navigator.geolocation) {
			setLocationError("Tu navegador no soporta geolocalización");
			return;
		}

		setGettingLocation(true);
		setLocationError("");

		const options = {
			enableHighAccuracy: true,
			timeout: 10000,
			maximumAge: 60000, // 1 minuto
		};

		navigator.geolocation.getCurrentPosition(
			(position) => {
				const { latitude, longitude } = position.coords;
				setFormData((prev) => ({
					...prev,
					latitude: latitude.toFixed(6),
					longitude: longitude.toFixed(6),
				}));
				setSuccess("¡Ubicación obtenida exitosamente!");
				setGettingLocation(false);
			},
			(error) => {
				let errorMessage = "";
				switch (error.code) {
					case error.PERMISSION_DENIED:
						errorMessage =
							"Permisos de ubicación denegados. Por favor, permite el acceso a tu ubicación.";
						break;
					case error.POSITION_UNAVAILABLE:
						errorMessage = "Información de ubicación no disponible.";
						break;
					case error.TIMEOUT:
						errorMessage =
							"Tiempo de espera agotado para obtener la ubicación.";
						break;
					default:
						errorMessage = "Error desconocido al obtener la ubicación.";
						break;
				}
				setLocationError(errorMessage);
				setGettingLocation(false);
			},
			options
		);
	};

	const handleMenuUpload = async (menuData) => {
		try {
			setUploadingMenu(true);
			setError("");
			const token = getToken();

			const formData = new FormData();
			formData.append("url", menuData.url);
			formData.append("title", menuData.title);
			formData.append("menu_type", menuData.menu_type);
			formData.append("is_active", menuData.is_active);
			if (menuData.description)
				formData.append("description", menuData.description);
			if (menuData.valid_from)
				formData.append("valid_from", menuData.valid_from);
			if (menuData.valid_to) formData.append("valid_to", menuData.valid_to);

			const config = {
				headers: {
					Authorization: `JWT ${token}`,
					"Content-Type": "multipart/form-data",
				},
			};

			const res = await axios.post(
				`${process.env.REACT_APP_API_URL}${API}/business/my/menus/`,
				formData,
				config
			);

			setSuccess("¡Menú subido exitosamente!");
			setShowMenuModal(false);
			fetchBusinessProfile(); // Recargar datos
		} catch (err) {
			setError(err.response?.data?.detail || "Error al subir el menú");
		} finally {
			setUploadingMenu(false);
		}
	};

	const handleLogoUpload = async (file) => {
		if (!file) {
			console.error("No file provided to handleLogoUpload");
			return;
		}

		try {
			setUploadingLogo(true);
			setError("");
			const token = getToken();

			console.log("Token:", token ? "Present" : "Missing");

			const formData = new FormData();
			formData.append("logo", file, file.name); // Cambiado a 'logo' para la nueva API

			console.log("FormData created with file:", file.name);
			console.log("File size:", file.size);
			console.log("File type:", file.type);

			const config = {
				headers: {
					Authorization: `JWT ${token}`,
					// No establecer 'Content-Type' manualmente para FormData
				},
			};

			// Usar la nueva ruta específica para logos
			console.log(
				"Making POST request to:",
				`${process.env.REACT_APP_API_URL}${API}/business/my/logo/`
			);

			const res = await axios.post(
				`${process.env.REACT_APP_API_URL}${API}/business/my/logo/`,
				formData,
				config
			);

			console.log("Upload response:", res.data);
			setBusinessProfile(res.data.business); // La nueva API devuelve el business en una propiedad
			setSuccess(res.data.message || "¡Logo actualizado exitosamente!");
			setLogoPreview(null);
			// No necesitamos fetchBusinessProfile() ya que tenemos los datos en res.data
		} catch (err) {
			console.error("Error uploading logo:", err);
			console.error("Error response:", err.response?.data);

			let errorMessage = "Error al subir el logo";

			if (err.response?.data) {
				if (err.response.data.error) {
					errorMessage = err.response.data.error;
				} else if (err.response.data.detail) {
					errorMessage = err.response.data.detail;
				} else if (err.response.data.logo) {
					errorMessage = `Error en el logo: ${err.response.data.logo[0]}`;
				} else if (typeof err.response.data === "string") {
					errorMessage = err.response.data;
				}
			}

			setError(errorMessage);
		} finally {
			setUploadingLogo(false);
		}
	};

	const handleLogoDelete = async () => {
		if (!businessProfile?.logo) {
			return;
		}

		try {
			setUploadingLogo(true);
			setError("");
			const token = getToken();

			const config = {
				headers: {
					Authorization: `JWT ${token}`,
				},
			};

			console.log(
				"Making DELETE request to:",
				`${process.env.REACT_APP_API_URL}${API}/business/my/logo/`
			);

			const res = await axios.delete(
				`${process.env.REACT_APP_API_URL}${API}/business/my/logo/`,
				config
			);

			console.log("Delete response:", res.data);
			setBusinessProfile(res.data.business);
			setSuccess(res.data.message || "Logo eliminado exitosamente");
		} catch (err) {
			console.error("Error deleting logo:", err);

			let errorMessage = "Error al eliminar el logo";
			if (err.response?.data?.error) {
				errorMessage = err.response.data.error;
			}

			setError(errorMessage);
		} finally {
			setUploadingLogo(false);
		}
	};

	const handleLogoFileChange = (e) => {
		const file = e.target.files[0];
		if (file) {
			console.log("Selected file:", file);
			console.log("File type:", file.type);
			console.log("File size:", file.size);

			// Validar tipo de archivo
			const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
			if (!allowedTypes.includes(file.type)) {
				setError("Solo se permiten imágenes JPG o PNG para el logo");
				return;
			}

			// Validar tamaño (máximo 5MB)
			if (file.size > 5 * 1024 * 1024) {
				setError("El logo no debe superar los 5MB");
				return;
			}

			// Limpiar errores previos
			setError("");

			// Crear preview
			const reader = new FileReader();
			reader.onload = (event) => {
				console.log("Preview created successfully");
				setLogoPreview(event.target.result);
			};
			reader.onerror = (error) => {
				console.error("Error reading file:", error);
				setError("Error al procesar la imagen");
			};
			reader.readAsDataURL(file);

			// Subir directamente
			console.log("Starting logo upload...");
			handleLogoUpload(file);
		}
	};

	const handleDeleteMenu = async (menuId) => {
		if (!window.confirm("¿Estás seguro de que quieres eliminar este menú?")) {
			return;
		}

		try {
			const token = getToken();
			const config = { headers: { Authorization: `JWT ${token}` } };

			await axios.delete(
				`${process.env.REACT_APP_API_URL}${API}/business/my/menus/${menuId}/`,
				config
			);

			setSuccess("Menú eliminado exitosamente");
			fetchBusinessProfile(); // Recargar datos
		} catch (err) {
			setError("Error al eliminar el menú");
		}
	};

	const saveProfile = async () => {
		try {
			setSaving(true);
			setError("");
			setSuccess("");
			const token = getToken();
			const config = {
				headers: {
					Authorization: `JWT ${token}`,
					"Content-Type": "application/json",
				},
			};

			// Limpiar horarios: si un día está cerrado, solo enviar closed: true
			const cleanedOperatingHours = {};
			Object.keys(formData.operating_hours).forEach((day) => {
				const dayData = formData.operating_hours[day];
				if (dayData.closed) {
					cleanedOperatingHours[day] = { closed: true };
				} else {
					cleanedOperatingHours[day] = {
						closed: false,
						open: dayData.open || "09:00",
						close: dayData.close || "18:00",
					};
				}
			});

			const cleanedFormData = {
				...formData,
				operating_hours: cleanedOperatingHours,
			};

			const res = await axios.put(
				`${process.env.REACT_APP_API_URL}${API}/business/my/`,
				cleanedFormData,
				config
			);

			setBusinessProfile(res.data);
			setSuccess("¡Perfil actualizado exitosamente!");
			fetchBusinessProfile();
		} catch (err) {
			setError(err.response?.data?.detail || "Error al guardar el perfil");
		} finally {
			setSaving(false);
		}
	};

	const isRestaurantType = ["RESTAURANT", "CAFE", "BAR", "HOTEL"].includes(
		formData.business_type
	);

	// --- UI ---
	if (loading) {
		return (
			<DashboardLayout>
				<div className="flex justify-center items-center h-64">
					<div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500" />
				</div>
			</DashboardLayout>
		);
	}

	if (error && !businessProfile) {
		return (
			<DashboardLayout>
				<div className="max-w-xl mx-auto mt-10 px-4">
					<div className="bg-red-50 border border-red-200 text-red-700 p-4 rounded-lg">
						<p className="font-semibold mb-1">Error</p>
						<p className="text-sm">{error}</p>
					</div>
				</div>
			</DashboardLayout>
		);
	}

	return (
		<DashboardLayout>
			<Meta title="Mi Restaurante - Perfil de Negocio" />

			{/* Header */}
			<div className="mb-6 px-4 sm:px-6">
				<div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
					<div>
						<h1 className="text-2xl sm:text-3xl font-bold text-gray-900">
							Mi Restaurante
						</h1>
						<p className="text-gray-600 mt-1">
							Gestiona toda la información de tu negocio
						</p>
					</div>

					<div className="flex flex-col sm:flex-row gap-2 sm:gap-3">
						<button
							onClick={saveProfile}
							disabled={saving}
							className="w-full sm:w-auto px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50 inline-flex items-center justify-center gap-2"
						>
							<IconEdit className="h-4 w-4" />
							<span>{saving ? "Guardando..." : "Guardar Cambios"}</span>
						</button>
					</div>
				</div>
			</div>

			{/* Alerts */}
			<div className="px-4 sm:px-6">
				{error && (
					<div className="mb-4 bg-red-50 border border-red-200 text-red-700 p-4 rounded-lg">
						{error}
					</div>
				)}
				{success && (
					<div className="mb-4 bg-green-50 border border-green-200 text-green-700 p-4 rounded-lg">
						{success}
					</div>
				)}
			</div>

			{/* Estado del perfil */}
			{businessProfile && (
				<div className="mb-4 px-4 sm:px-6">
					<div className="rounded-lg p-4 bg-blue-50 border border-blue-200">
						<div className="flex items-start gap-3">
							<div className="p-2 rounded-full bg-blue-100">
								<IconBuilding className="h-5 w-5 text-blue-600" />
							</div>
							<div>
								<h3 className="font-semibold text-blue-800">
									Perfil de Negocio
								</h3>
								<p className="text-sm text-blue-600">
									Gestiona toda la información de tu restaurante desde aquí
								</p>
								{businessProfile.is_active && (
									<p className="text-xs text-green-600 mt-1">
										✓ Perfil activo y visible para clientes
									</p>
								)}
							</div>
						</div>
					</div>
				</div>
			)}

			{/* Tabs Sticky + Scrollable */}
			<div className="sticky top-0 z-20 bg-white/90 backdrop-blur supports-[backdrop-filter]:bg-white/60 border-b">
				<div className="px-2 sm:px-6 py-2 overflow-x-auto">
					<div className="flex items-center gap-2 sm:gap-3 min-w-max">
						{tabs.map((tab) => {
							const Icon = tab.icon;
							const selected = activeTab === tab.id;
							return (
								<button
									key={tab.id}
									onClick={() => setActiveTab(tab.id)}
									className={[
										"shrink-0 inline-flex items-center gap-2 rounded-full border px-3 py-2 text-sm font-medium transition",
										selected
											? "bg-blue-600 text-white border-blue-600"
											: "bg-white text-gray-700 border-gray-200 hover:bg-gray-50",
									].join(" ")}
									aria-selected={selected}
								>
									<Icon className="h-4 w-4" />
									<span>{tab.label}</span>
								</button>
							);
						})}
					</div>
				</div>
			</div>

			{/* Content */}
			<div className="p-4 sm:p-6">
				{/* BASIC */}
				{activeTab === "basic" && (
					<div className="space-y-6">
						{/* Logo del Negocio */}
						<div className="border border-gray-200 rounded-lg p-6">
							<h3 className="text-lg font-medium text-gray-900 mb-4">
								Logo del Negocio
							</h3>

							<div className="flex flex-col sm:flex-row gap-6 items-start">
								{/* Preview del logo actual o placeholder */}
								<div className="flex-shrink-0">
									<div className="w-32 h-32 border-2 border-dashed border-gray-300 rounded-lg flex items-center justify-center bg-gray-50">
										{businessProfile?.logo || logoPreview ? (
											<img
												src={
													logoPreview ||
													(businessProfile.logo?.startsWith("http")
														? businessProfile.logo
														: process.env.REACT_APP_API_URL +
														  businessProfile.logo)
												}
												alt="Logo del negocio"
												className="w-full h-full object-cover rounded-lg"
											/>
										) : (
											<div className="text-center">
												<IconBuilding className="h-8 w-8 text-gray-400 mx-auto mb-2" />
												<p className="text-xs text-gray-500">Sin logo</p>
											</div>
										)}
									</div>
								</div>

								{/* Controles de upload */}
								<div className="flex-1">
									<div className="mb-3">
										<label className="block text-sm font-medium text-gray-700 mb-2">
											Subir nuevo logo
										</label>
										<input
											type="file"
											onChange={handleLogoFileChange}
											accept=".jpg,.jpeg,.png"
											className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-medium file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
											disabled={uploadingLogo}
										/>
									</div>

									<div className="text-xs text-gray-500 space-y-1">
										<p>• Formatos permitidos: JPG, PNG</p>
										<p>• Tamaño máximo: 5MB</p>
										<p>• Recomendado: 300x300px o superior</p>
									</div>

									{uploadingLogo && (
										<div className="mt-3 flex items-center gap-2 text-sm text-blue-600">
											<div className="w-4 h-4 border-2 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
											<span>Subiendo logo...</span>
										</div>
									)}

									{/* Botón para eliminar logo */}
									{businessProfile?.logo && !uploadingLogo && (
										<div className="mt-3">
											<button
												type="button"
												onClick={handleLogoDelete}
												className="text-sm text-red-600 hover:text-red-800 underline"
												disabled={uploadingLogo}
											>
												Eliminar logo actual
											</button>
										</div>
									)}
								</div>
							</div>
						</div>

						{/* Información básica del negocio */}
						<div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
							<div>
								<label className="block text-sm font-medium text-gray-700 mb-2">
									Nombre del Negocio *
								</label>
								<input
									type="text"
									name="business_name"
									value={formData.business_name}
									onChange={handleInputChange}
									className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
									placeholder="Nombre de tu restaurante"
								/>
							</div>

							<div>
								<label className="block text-sm font-medium text-gray-700 mb-2">
									Tipo de Negocio
								</label>
								<select
									name="business_type"
									value={formData.business_type}
									onChange={handleInputChange}
									className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
								>
									{businessTypes.map((type) => (
										<option key={type.value} value={type.value}>
											{type.label}
										</option>
									))}
								</select>
							</div>

							<div>
								<label className="block text-sm font-medium text-gray-700 mb-2">
									Especialidad
								</label>
								<input
									type="text"
									name="specialty"
									value={formData.specialty}
									onChange={handleInputChange}
									className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
									placeholder={
										isRestaurantType
											? "Ej: Cocina italiana, Comida rápida"
											: "Ej: Tecnología, Consultoría"
									}
								/>
							</div>

							{isRestaurantType && (
								<div>
									<label className="block text-sm font-medium text-gray-700 mb-2">
										Cantidad de Mesas
									</label>
									<input
										type="number"
										name="number_of_tables"
										value={formData.number_of_tables}
										onChange={handleInputChange}
										className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
										placeholder="Número de personas"
										min="1"
									/>
								</div>
							)}

							<div>
								<label className="block text-sm font-medium text-gray-700 mb-2">
									Año de Fundación
								</label>
								<input
									type="number"
									name="founded_year"
									value={formData.founded_year}
									onChange={handleInputChange}
									className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
									placeholder="Ej: 2020"
									min="1900"
									max={new Date().getFullYear()}
								/>
							</div>
						</div>

						<div>
							<label className="block text-sm font-medium text-gray-700 mb-2">
								Descripción *
							</label>
							<textarea
								name="description"
								value={formData.description}
								onChange={handleInputChange}
								rows={4}
								className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
								placeholder="Describe tu negocio, qué ofreces, qué te hace especial..."
							/>
						</div>
					</div>
				)}

				{/* LOCATION */}
				{activeTab === "location" && (
					<div className="space-y-6">
						<div>
							<label className="block text-sm font-medium text-gray-700 mb-2">
								Dirección Completa *
							</label>
							<textarea
								name="address"
								value={formData.address}
								onChange={handleInputChange}
								rows={2}
								className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
								placeholder="Dirección completa de tu negocio"
							/>
						</div>

						<div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
							<div>
								<label className="block text-sm font-medium text-gray-700 mb-2">
									Ciudad *
								</label>
								<input
									type="text"
									name="city"
									value={formData.city}
									onChange={handleInputChange}
									className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
									placeholder="Ciudad"
								/>
							</div>

							<div>
								<label className="block text-sm font-medium text-gray-700 mb-2">
									Estado/Departamento
								</label>
								<input
									type="text"
									name="state"
									value={formData.state}
									onChange={handleInputChange}
									className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
									placeholder="Estado o departamento"
								/>
							</div>

							<div>
								<label className="block text-sm font-medium text-gray-700 mb-2">
									Código Postal
								</label>
								<input
									type="text"
									name="postal_code"
									value={formData.postal_code}
									onChange={handleInputChange}
									className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
									placeholder="Código postal"
								/>
							</div>
						</div>

						<div>
							<label className="block text-sm font-medium text-gray-700 mb-2">
								País
							</label>
							<input
								type="text"
								name="country"
								value={formData.country}
								onChange={handleInputChange}
								className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
								placeholder="País"
							/>
						</div>

						{/* Campos ocultos para latitud y longitud */}
						<input type="hidden" name="latitude" value={formData.latitude} />
						<input type="hidden" name="longitude" value={formData.longitude} />

						{/* Sección de geolocalización */}
						<div className="border border-gray-200 rounded-lg p-4">
							<div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-3">
								<div>
									<h4 className="font-medium text-gray-900">Ubicación GPS</h4>
									<p className="text-sm text-gray-600">
										Permite que obtengamos tu ubicación exacta para mejorar la
										precisión en mapas
									</p>
								</div>
								<button
									type="button"
									onClick={getCurrentLocation}
									disabled={gettingLocation}
									className="w-full sm:w-auto px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 disabled:opacity-50 inline-flex items-center justify-center gap-2"
								>
									<IconCurrentLocation className="h-4 w-4" />
									<span>
										{gettingLocation ? "Obteniendo..." : "Obtener Mi Ubicación"}
									</span>
								</button>
							</div>

							{/* Estado de la ubicación */}
							{formData.latitude && formData.longitude && (
								<div className="bg-green-50 border border-green-200 rounded-lg p-3">
									<div className="flex items-center gap-2">
										<IconCheck className="h-4 w-4 text-green-600" />
										<span className="text-sm text-green-700 font-medium">
											Ubicación GPS configurada
										</span>
									</div>
									<p className="text-xs text-green-600 mt-1">
										Coordenadas: {parseFloat(formData.latitude).toFixed(4)},{" "}
										{parseFloat(formData.longitude).toFixed(4)}
									</p>
								</div>
							)}

							{locationError && (
								<div className="bg-red-50 border border-red-200 rounded-lg p-3">
									<div className="flex items-start gap-2">
										<IconAlertTriangle className="h-4 w-4 text-red-600 mt-0.5" />
										<div>
											<span className="text-sm text-red-700 font-medium">
												Error de ubicación
											</span>
											<p className="text-xs text-red-600 mt-1">
												{locationError}
											</p>
										</div>
									</div>
								</div>
							)}

							{!formData.latitude && !formData.longitude && !locationError && (
								<div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
									<p className="text-sm text-blue-700">
										<strong>Recomendado:</strong> Obtén tu ubicación GPS para
										que los clientes puedan encontrarte más fácilmente en
										aplicaciones de delivery y mapas.
									</p>
								</div>
							)}
						</div>
					</div>
				)}

				{/* CONTACT */}
				{activeTab === "contact" && (
					<div className="space-y-6">
						<div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
							<div>
								<label className="block text-sm font-medium text-gray-700 mb-2">
									Teléfono Principal *
								</label>
								<input
									type="tel"
									name="phone_main"
									value={formData.phone_main}
									onChange={handleInputChange}
									className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
									placeholder="+57 300 123 4567"
								/>
							</div>

							<div>
								<label className="block text-sm font-medium text-gray-700 mb-2">
									Email del Negocio
								</label>
								<input
									type="email"
									name="email_business"
									value={formData.email_business}
									onChange={handleInputChange}
									className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
									placeholder="contacto@mirestaurante.com"
								/>
							</div>

							<div className="sm:col-span-2">
								<label className="block text-sm font-medium text-gray-700 mb-2">
									Sitio Web
								</label>
								<input
									type="url"
									name="website"
									value={formData.website}
									onChange={handleInputChange}
									className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
									placeholder="https://www.mirestaurante.com"
								/>
							</div>
						</div>
					</div>
				)}

				{/* HOURS */}
				{activeTab === "hours" && (
					<div className="space-y-4">
						<h3 className="text-lg font-medium text-gray-900">
							Horarios de Operación
						</h3>
						<div className="space-y-4">
							{Object.entries(dayNames).map(([dayKey, dayLabel]) => (
								<div
									key={dayKey}
									className="flex flex-col sm:flex-row sm:items-center gap-3 p-4 border border-gray-200 rounded-lg"
								>
									<div className="sm:w-28 text-sm font-medium text-gray-700">
										{dayLabel}
									</div>

									<label className="inline-flex items-center gap-2">
										<input
											type="checkbox"
											checked={
												formData.operating_hours[dayKey]?.closed || false
											}
											onChange={(e) =>
												handleHoursChange(dayKey, "closed", e.target.checked)
											}
											className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
										/>
										<span className="text-sm text-gray-600">Cerrado</span>
									</label>

									{!formData.operating_hours[dayKey]?.closed && (
										<div className="flex items-center gap-2">
											<input
												type="time"
												value={
													formData.operating_hours[dayKey]?.open || "09:00"
												}
												onChange={(e) =>
													handleHoursChange(dayKey, "open", e.target.value)
												}
												className="rounded-md border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
											/>
											<span className="text-sm text-gray-500">a</span>
											<input
												type="time"
												value={
													formData.operating_hours[dayKey]?.close || "18:00"
												}
												onChange={(e) =>
													handleHoursChange(dayKey, "close", e.target.value)
												}
												className="rounded-md border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
											/>
										</div>
									)}
								</div>
							))}
						</div>
					</div>
				)}

				{/* FEATURES */}
				{activeTab === "features" && (
					<div className="space-y-6">
						<h3 className="text-lg font-medium text-gray-900">
							Servicios y Características
						</h3>
						<div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
							{commonFeatures.map((feature) => (
								<label
									key={feature}
									className="flex items-center p-3 border border-gray-200 rounded-lg hover:bg-gray-50 cursor-pointer"
								>
									<input
										type="checkbox"
										checked={formData.features.includes(feature)}
										onChange={() => handleFeatureToggle(feature)}
										className="mr-3 h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
									/>
									<span className="text-sm text-gray-700">{feature}</span>
								</label>
							))}
						</div>
					</div>
				)}

				{/* SOCIAL */}
				{activeTab === "social" && (
					<div className="space-y-6">
						<h3 className="text-lg font-medium text-gray-900">
							Redes Sociales
						</h3>
						<div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
							{[
								["facebook", "Facebook", "https://facebook.com/mirestaurante"],
								[
									"instagram",
									"Instagram",
									"https://instagram.com/mirestaurante",
								],
								["whatsapp", "WhatsApp", "+57 300 123 4567"],
								["twitter", "Twitter", "https://twitter.com/mirestaurante"],
								[
									"linkedin",
									"LinkedIn",
									"https://linkedin.com/company/mirestaurante",
								],
							].map(([key, label, placeholder]) => (
								<div key={key}>
									<label className="block text-sm font-medium text-gray-700 mb-2">
										{label}
									</label>
									<input
										type={key === "whatsapp" ? "tel" : "url"}
										name={`social_media.${key}`}
										value={formData.social_media[key]}
										onChange={handleInputChange}
										className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
										placeholder={placeholder}
									/>
								</div>
							))}
						</div>
					</div>
				)}

				{/* MENUS */}
				{activeTab === "menus" && (
					<div className="space-y-6">
						<div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
							<div>
								<h3 className="text-lg font-medium text-gray-900">
									Menús del Negocio
								</h3>
								<p className="text-sm text-gray-600">
									Gestiona los menús y cartas de tu restaurante
								</p>
							</div>
							<button
								onClick={() => setShowMenuModal(true)}
								className="w-full sm:w-auto px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 inline-flex items-center justify-center gap-2"
							>
								<IconUpload className="h-4 w-4" />
								<span>Subir Menú</span>
							</button>
						</div>

						{businessProfile?.menus && businessProfile.menus.length > 0 ? (
							<div className="space-y-4">
								{/* Resumen de menús */}
								<div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
									<div className="flex items-center gap-3">
										<IconMenu2 className="h-5 w-5 text-blue-600" />
										<div>
											<h4 className="font-medium text-blue-800">
												{businessProfile.menus.length} menú
												{businessProfile.menus.length !== 1 ? "s" : ""}{" "}
												registrado
												{businessProfile.menus.length !== 1 ? "s" : ""}
											</h4>
											<p className="text-sm text-blue-600">
												{
													businessProfile.menus.filter((m) => m.is_active)
														.length
												}{" "}
												activo
												{businessProfile.menus.filter((m) => m.is_active)
													.length !== 1
													? "s"
													: ""}{" "}
												•{" "}
												{
													businessProfile.menus.filter((m) => !m.is_active)
														.length
												}{" "}
												inactivo
												{businessProfile.menus.filter((m) => !m.is_active)
													.length !== 1
													? "s"
													: ""}
											</p>
										</div>
									</div>
								</div>

								{/* Lista de menús */}
								<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
									{businessProfile.menus.map((menu) => (
										<div
											key={menu.id}
											className="border border-gray-200 rounded-lg overflow-hidden hover:shadow-md transition-shadow"
										>
											{/* Imagen preview si es imagen */}
											{menu.file &&
												(menu.file.includes(".jpg") ||
													menu.file.includes(".jpeg") ||
													menu.file.includes(".png")) && (
													<div className="h-32 bg-gray-100">
														<img
															src={menu.file}
															alt={menu.title}
															className="w-full h-full object-cover"
														/>
													</div>
												)}

											<div className="p-4">
												<div className="flex items-start justify-between mb-2">
													<div className="flex-1">
														<h4 className="font-medium text-gray-900 truncate">
															{menu.title}
														</h4>
														<p className="text-sm text-gray-600">
															{menuTypes.find((t) => t.value === menu.menu_type)
																?.label || menu.menu_type}
														</p>
													</div>
													<span
														className={`px-2 py-1 rounded-full text-xs font-medium ${
															menu.is_active
																? "bg-green-100 text-green-800"
																: "bg-gray-100 text-gray-800"
														}`}
													>
														{menu.is_active ? "Activo" : "Inactivo"}
													</span>
												</div>

												{menu.description && (
													<p className="text-xs text-gray-600 mb-2 line-clamp-2">
														{menu.description}
													</p>
												)}

												{menu.valid_from && menu.valid_to && (
													<p className="text-xs text-gray-500 mb-3">
														📅 {new Date(menu.valid_from).toLocaleDateString()}{" "}
														- {new Date(menu.valid_to).toLocaleDateString()}
													</p>
												)}

												<div className="text-xs text-gray-500 mb-3">
													📁{" "}
													{menu.file?.includes(".pdf")
														? "PDF"
														: menu.file?.includes(".jpg") ||
														  menu.file?.includes(".jpeg") ||
														  menu.file?.includes(".png")
														? "Imagen"
														: "Archivo"}
													{menu.created_at && (
														<span className="ml-2">
															• Creado{" "}
															{new Date(menu.created_at).toLocaleDateString()}
														</span>
													)}
												</div>

												<div className="flex gap-2">
													<a
														href={menu.file}
														target="_blank"
														rel="noopener noreferrer"
														className="flex-1 px-3 py-2 text-sm bg-blue-50 text-blue-700 rounded hover:bg-blue-100 text-center font-medium transition-colors"
													>
														👁️ Ver
													</a>
													<button
														onClick={() => handleDeleteMenu(menu.id)}
														className="flex-1 px-3 py-2 text-sm bg-red-50 text-red-700 rounded hover:bg-red-100 font-medium transition-colors"
													>
														🗑️ Eliminar
													</button>
												</div>
											</div>
										</div>
									))}
								</div>
							</div>
						) : (
							<div className="text-center py-16 border-2 border-dashed border-gray-300 rounded-lg bg-gray-50/50">
								<div className="space-y-4">
									<div className="flex justify-center">
										<div className="p-4 bg-blue-100 rounded-full">
											<IconMenu2 className="h-8 w-8 text-blue-600" />
										</div>
									</div>
									<div>
										<h3 className="text-lg font-medium text-gray-900 mb-2">
											No tienes menús registrados
										</h3>
										<p className="text-gray-500 mb-1">
											Sube los menús de tu restaurante para que los clientes
											puedan verlos
										</p>
										<p className="text-sm text-gray-400">
											Formatos soportados: PDF, JPG, PNG (hasta 10MB)
										</p>
									</div>
									<button
										onClick={() => setShowMenuModal(true)}
										className="inline-flex items-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-md hover:bg-blue-700 font-medium transition-colors"
									>
										<IconUpload className="h-5 w-5" />
										<span>Subir Primer Menú</span>
									</button>
								</div>
							</div>
						)}

						{/* Modal para subir menú */}
						{showMenuModal && (
							<MenuUploadModal
								onClose={() => setShowMenuModal(false)}
								onUpload={handleMenuUpload}
								uploading={uploadingMenu}
								menuTypes={menuTypes}
							/>
						)}
					</div>
				)}
			</div>
		</DashboardLayout>
	);
}

const mapStateToProps = (state) => ({
	user: state.auth.user,
	access: state.auth.access,
});

export default connect(mapStateToProps)(BusinessProfile);
